const getUrlParameterByName = (name, url) => {
    let paramUrl = url;
    const paramName = name.replace(/[\\]/g, '\\$&');
    if (!paramUrl) paramUrl = window.location.href;
    const regex = new RegExp('[?&]' + paramName + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(paramUrl);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const getTokenFromUrl = () => {
    const tokenMatch = window.location.href.match(/form\/([^?/]*)/);
    return tokenMatch && tokenMatch[1];
};

const goToUrl = url => {
    window.location.href = url;
};

export {
    goToUrl,
    getTokenFromUrl,
    getUrlParameterByName
}
